import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import ticketIcon from "./icon/ticket.png";
import { useTranslation } from 'react-i18next';
import {Link} from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: 'rgba(171, 171, 171, 0.1)',
    //height: '55px',
    margin: '1rem',
  },
  total: {
    display: 'flex',
    marginTop: 30,
    justifyContent: 'center',
    alignItems: 'center',
    '& h6': {
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 700,
    },
  },
  listItem: {
    background: 'white',
    minHeight: '55px',
    margin: '5px 0',
    //padding: '1rem',
    borderRadius: '1rem',
  },
  listItemLink: {
    height: "61px"
  },
  label: {
    margin: '0 1rem',
    fontSize: "22px"
  },
  bold: {
    fontWeight: 700,
  },
  Title: {
    opacity: 1,
    color: "rgba(38,41,87,1)",
    fontFamily: "FuturaStdBold",
    fontSize: "30px",
    fontWeight: 700,
    fontStyle: "normal",
    letterSpacing: "0px",
    textAlign: "center",
    lineHeight: "36px",
    marginBottom: "50px",
    '& span': {
      backgroundImage: "linear-gradient(90deg, #262957, #5AC8F5)",
      "-webkit-background-clip": "text",
      '-webkit-text-fill-color': "transparent",
      "-moz-background-clip": "text",
      "-moz-text-fill-color": "transparent",
    }
  },
  listContainer: {
    padding: "50px 0",
    background: "radial-gradient(circle at center, rgba(90, 200, 245, 0.1) 60%,#f8f5f9 47%)"
  }
}));

const TicketRequestForm = ({ticketId, paymentId, payment}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid className={classes.root}>
        <Grid item xs={12} className={classes.total}>
          <img src={ticketIcon} width="130px"/>
        </Grid>
        <Grid item xs={12} className={classes.total}>
          <Typography display="inline" className={classes.Title}>
            <span>Vos tickets</span> <span>dématérialisés</span>
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.listContainer}>
          <Link
            to={`/ticket/:${ticketId}/requestTicket/${paymentId}/type/order`}
            className={classes.listItemLink}
            //onClick={(e) => handleClick(e, paymentId)}
          >
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className={classes.listItem}
            >

              <Grid item>
                <Typography display="inline" className={classes.label}>
                  {t('theOrderReceipt')}
                </Typography>
              </Grid>

                <Grid item style={{height: "61px"}}>
                    <svg id="SVGDoc" width="53" height="61" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 53 61"><defs></defs><g><g><title>Path 2</title><path d="M20,20v0l13,10.5v0l-13,10.5v0" fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeDasharray="" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" stroke="#e84249" strokeMiterlimit="20" strokeWidth="2"></path></g></g></svg>
                </Grid>
            </Grid>
          </Link>
          <Link
            to={`/ticket/:${ticketId}/requestTicket/${paymentId}/type/paymentLine`}
            className={classes.listItemLink}
            //onClick={(e) => handleClick(e, paymentId)}
          >
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className={classes.listItem}
            >

              <Grid item>
                <Typography display="inline" className={classes.label}>
                  {t('theSupportingDocument')}
                </Typography>
              </Grid>

                <Grid item style={{height: "61px"}}>
                  <svg id="SVGDoc" width="53" height="61" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 53 61"><defs></defs><g><g><title>Path 2</title><path d="M20,20v0l13,10.5v0l-13,10.5v0" fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeDasharray="" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" stroke="#e84249" strokeMiterlimit="20" strokeWidth="2"></path></g></g></svg>
                </Grid>
            </Grid>
          </Link>
          {payment && payment.tpe_pay_plus ? (<Link
            to={`/ticket/:${ticketId}/requestCbTicket/${paymentId}`}
            //onClick={(e) => handleClick(e, paymentId)}
            className={classes.listItemLink}
          >
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className={classes.listItem}
            >

              <Grid item>
                <Typography display="inline" className={classes.label}>
                  {t('theCardReceipt')}
                </Typography>
              </Grid>
                <Grid item style={{height: "61px"}}>
                  <svg id="SVGDoc" width="53" height="61" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 53 61"><defs></defs><g><g><title>Path 2</title><path d="M20,20v0l13,10.5v0l-13,10.5v0" fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeDasharray="" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" stroke="#e84249" strokeMiterlimit="20" strokeWidth="2"></path></g></g></svg>
                </Grid>
            </Grid>
          </Link>) : null}

        </Grid>
      </Grid>
  )
}

export default TicketRequestForm;